<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Promotions Management</v-toolbar-title>
        <v-spacer />
        <v-btn text color="white" @click="$router.push('/promotions')">
          <v-icon left>
            mdi-view-list
          </v-icon>
          List
        </v-btn>
        <v-btn text color="white" @click="$router.push('/promotions/create')">
          <v-icon left>
            mdi-plus
          </v-icon>
          New
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <router-view />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'PromotionPage',
}
</script>
